import { render, staticRenderFns } from "./mortgage-and-property.vue?vue&type=template&id=b6927522"
import script from "./mortgage-and-property.vue?vue&type=script&lang=js"
export * from "./mortgage-and-property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports